import script from "./NewsPageSwitcherMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageSwitcherMenu.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageSwitcherMenu.vue?vue&type=style&index=0&id=276d6626&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276d6626"]])

export default __exports__